export const SITE = {
  name: 'Pouria Maleki',
  faName: 'پوریا ملکی',
  aliases: ['Pouria Maleki', 'پوریا ملکی', 'Pooria Maleki', 'Poria Maleki', 'Poriya Maleki'],
  url: 'https://pouriamaleki.com',
  email: 'p.maleki.1994@gmail.com',
  location: { en: 'Hamedan, Iran', fa: 'همدان، ایران' },
  social: {
    linkedin: 'https://www.linkedin.com/in/pouria-maleki',
    scholar: 'https://scholar.google.com/citations?user=YkH4p6kAAAAJ&hl=en',
    researchGate: 'https://www.researchgate.net/profile/Pouria-Maleki',
    github: 'https://github.com/pouria-maleki'
  },
  personId: 'https://pouriamaleki.com/about#pouria-maleki'
}

export const references = [
  { name: 'Dr. Amir Mosavi', role: { en: 'Associate Professor', fa: 'دانشیار' }, affiliation: { en: 'Óbuda University, Faculty of Informatics, Budapest, Hungary · TU Dresden, Faculty of Civil Engineering, Germany', fa: 'دانشگاه اوبودا، دانشکده انفورماتیک، بوداپست · دانشگاه فنی درسدن، دانشکده مهندسی عمران، آلمان' }, email: 'amir.mosavi@kvk.uni-obuda.hu' },
  { name: 'Dr. Hassan Khotanlou', role: { en: 'Professor, Computer Engineering', fa: 'استاد مهندسی کامپیوتر' }, affiliation: { en: 'Bu-Ali Sina University, Hamedan, Iran', fa: 'دانشگاه بوعلی سینا، همدان، ایران' }, email: 'khotanlou@basu.ac.ir' },
  { name: 'Dr. Abbas Ramazani', role: { en: 'Assistant Professor, Electrical Engineering', fa: 'استادیار مهندسی برق' }, affiliation: { en: 'Bu-Ali Sina University, Hamedan, Iran', fa: 'دانشگاه بوعلی سینا، همدان، ایران' }, email: 'a.ramazani@basu.ac.ir' },
  { name: 'Dr. Soheil Ganjefar', role: { en: 'Professor, Electrical Engineering', fa: 'استاد مهندسی برق' }, affiliation: { en: 'Iran University of Science and Technology, Tehran, Iran', fa: 'دانشگاه علم و صنعت ایران، تهران' }, email: 's_ganjefar@iust.ac.ir' }
]
